import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./SyncLogs.css";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles, formatSyncFrom } from "constants/titles";
import { getAppBuildVersionDisplay } from "utility/deviceDetailUtils";
import { convertInRequiredTimeZone } from "utility";
import { useSelector } from "react-redux";

const SyncLogs = () => {
  const history = useHistory();
  const location = useLocation();
  const syncLogs = location?.state?.logs || [];
  const syncId = location?.state?.syncId || null;

  const { selectedMedicalUser } = useSelector(
    (store) => store?.medicalAlertUsers
  );
  const { currentTimeZone } = useSelector((store) => store?.common);

  const convertInLocalTimeZone = (date) => {
    return convertInRequiredTimeZone(
      date,
      selectedMedicalUser?.timezone,
      currentTimeZone,
      false,
      true
    );
  };

  return (
    <MainLayout
      text={titles?.sync_logs}
      isBackHide={false}
      isSemiHeader={true}
      white={true}
      onBackClick={() => history.goBack()}
    >
      <div className="sl_container">
        {syncId && (
          <div className="sl_sync_id_header">
            <span className="sl_sync_id_label">{titles?.sync_id}:</span>
            <span className="sl_sync_id_value">#{syncId}</span>
          </div>
        )}

        <div className="sl_logs_container">
          {syncLogs?.length > 0 ? (
            syncLogs.map((item, index) => {
              return (
                <div key={index} className="sl_log_item">
                  <div className="sl_log_content">
                    <div className="sl_log_message">
                      {item.log}
                    </div>
                    
                    <div className="sl_log_metadata">
                      {item?.loggedBy && (
                        <div className="sl_metadata_row">
                          <span className="sl_metadata_label">
                            {titles?.logged_by}
                          </span>
                          <span className="sl_metadata_value">
                            {formatSyncFrom(item?.loggedBy)}
                          </span>
                        </div>
                      )}
                      
                      {item?.customerDeviceId && (
                        <div className="sl_metadata_row">
                          <span className="sl_metadata_label">
                            {titles?.customer_device_id}
                          </span>
                          <span className="sl_metadata_value">
                            {item?.customerDeviceId}
                          </span>
                        </div>
                      )}
                      
                      {item?.guestDeviceId && (
                        <div className="sl_metadata_row">
                          <span className="sl_metadata_label">
                            {titles?.guest_device_id}
                          </span>
                          <span className="sl_metadata_value">
                            {item?.guestDeviceId}
                          </span>
                        </div>
                      )}
                      
                      {item?.appBuildVersion && (
                        <div className="sl_metadata_row">
                          <span className="sl_metadata_label">
                            {titles?.app_build_version}
                          </span>
                          <span className="sl_metadata_value">
                            {getAppBuildVersionDisplay(item?.appBuildVersion)}
                          </span>
                        </div>
                      )}
                      
                      <div className="sl_metadata_row sl_timestamp_row">
                        <span className="sl_metadata_label">
                          {titles?.date || "Date"}
                        </span>
                        <span className="sl_metadata_value sl_timestamp">
                          {convertInLocalTimeZone(item?.loggedAt)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="sl_empty_state">
              <p className="sl_empty_message">{titles?.no_history_available}</p>
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default SyncLogs;

